import {createBrowserHistory, createMemoryHistory} from 'history';

const history = (!document.isJest && createBrowserHistory()) || createMemoryHistory();

export default history;